import DialRecordingContainer from '../../atoms/container/dialRecordingContainer';
import RecordStartIcon from '../../atoms/icons/recordStart';

function DialRecording() {
  return (
    <>
      <DialRecordingContainer>
        <RecordStartIcon />
      </DialRecordingContainer>
    </>
  );
}

export default DialRecording;
